import React, { useEffect, useState } from "react";
import IconCoin from "../../../mui/JSXIcons/IconCoin";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../store/index.ts";
import ShowContainer from "../../../mui/ShowContainer";
import useCampaigns from "../../../../hooks/other/useCampaigns.js";
import { ENUM_MODE_GAME, ENUM_USER_ACTIVE, TEST_MODE } from "../../../../store/enums.js";
import { testCampaignInfo } from "../../../../store/testConst.js";
import { updateImageUrl } from "../../../../utils/utils.js";
import "./welcome-step-fs.scss";
import { useDispatch } from "react-redux";
import { setModalBalance, setModalLogin } from "../../../../store/siteSlice.js";
import { setHardModeGame } from "../../../../store/commonSlice.js";
import useGameClick from "../../../../hooks/other/useGameClick.js";

export default function WelcomeBonusStep({
  currencyInfo,
  unavailableActive,
  // setOpenActiveBonus,
  userActiveStatus,
  statusForUser
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getCampaigns } = useCampaigns();
  const { onGameClick } = useGameClick();

  const currency = useAppSelector((state) => state.promotions.currency);
  const isAuth = useAppSelector((state) => state.user.isAuth);

  const [campaign, setCampaign] = useState({});

  const campaignId = currencyInfo?.campaignId;

  useEffect(() => {
    if (!campaignId) return;
    getCampaigns(campaignId).then((data) => {
      console.log("campaign", data);

      setCampaign(data);
    });

    if (TEST_MODE) {
      setCampaign(testCampaignInfo);
    }
  }, [campaignId]);

  const onRunGame = (game) => {
    console.log("game", game);

    dispatch(setHardModeGame(ENUM_MODE_GAME.real));
    onGameClick({ currentGame: game, url: "/game/", isChoose: false });
  };

  const onImgGameClick = (game) => {
    const isActivated = userActiveStatus === ENUM_USER_ACTIVE.activated;
    const isAnyStatus = userActiveStatus === ENUM_USER_ACTIVE.any;
    const bonusAccrued = statusForUser == ENUM_USER_ACTIVE.accrued;
    const bonusWait = statusForUser === ENUM_USER_ACTIVE.wait;
    const bonusDisabled = statusForUser === ENUM_USER_ACTIVE.disabled;
    // const isWait = userActiveStatus === ENUM_USER_ACTIVE.wait;

    if (!isAuth) return dispatch(setModalLogin(true));
    if (unavailableActive) return null;
    if (bonusAccrued) return onRunGame(game);
    if (bonusWait) return onRunGame(game);
    if (bonusDisabled) return null;
    if ((isActivated || isAnyStatus) && currencyInfo.maxDeposit) {
      return dispatch(setModalBalance(currencyInfo.maxDeposit));
    }
    // if (isWait) return setOpenActiveBonus(true);

    return null;
  };

  return (
    <div className="bonus_step">
      <div className="bonus_step__info">
        <span className="bonus_step__info__column">
          <span className="bonus_step__info__info__text__row">
            <span className="label label-percent">
              +<span className="percent">{currencyInfo.percent}% </span>
              {t("from the replenishment amount")}
            </span>
          </span>
          <span className="bonus_step__info__info__text__row">
            {currencyInfo.toDeposit
              ? t("Crediting to Deposit Balance")
              : t("Crediting to Bonus Balance")}
          </span>
        </span>

        <span className="bonus_step__info__info">
          <IconCoin />
          <span className="bonus_step__info__info__text">
            <span className="bonus_step__info__info__text__row">
              <span className="label">{t("Deposit from")}: </span>
              <span className="currency">
                {currencyInfo.minDeposit} {currency}
              </span>
            </span>
            <span className="bonus_step__info__info__text__row">
              <span className="label">{t("Deposit up to")}: </span>
              <span className="currency">
                {currencyInfo.maxDeposit} {currency}
              </span>
            </span>
          </span>
        </span>
        <span className="bonus_step__info__title">
          <span>
            {t("wager x", { wager: currencyInfo.wager })}{" "}
            {currencyInfo.cashout && t("cashout x", { cashout: currencyInfo.cashout })}
          </span>
        </span>
      </div>
      <ShowContainer condition={campaign.games?.length}>
        <div className="bonus_step__fs">
          <div className="bonus_step__fs__games">
            {campaign.games?.map((game) => (
              <div className="fs-game" key={game.id}>
                <div className="fs-game__img" onClick={() => onImgGameClick(game)}>
                  <img src={updateImageUrl(game.image)} />
                </div>
                <div className="fs-game__info">
                  <span className="fs-game__info__title">
                    <h4>{t(game.name)}</h4>
                    <ShowContainer condition={game.provider}>
                      <span className="fs-game__info__title__provider">({game.provider})</span>
                    </ShowContainer>
                  </span>
                  <span className="fs-game__info__field">
                    <span className="fs-game__info__field__name">{t("Freespins")}</span>
                    <span className="fs-game__info__field__value">{game.freespins}</span>
                  </span>
                  <span className="fs-game__info__field">
                    <span className="fs-game__info__field__name">{t("Rate")}</span>
                    <span className="fs-game__info__field__value">{game.bet.totalBet}</span>
                  </span>
                  <span className="fs-game__info__field">
                    <span className="fs-game__info__field__name">{t("Wager")}</span>
                    <span className="fs-game__info__field__value">{game.wager}</span>
                  </span>
                  <span className="fs-game__info__field">
                    <span className="fs-game__info__field__name">{t("Cash out")}</span>
                    <span className="fs-game__info__field__value">{game.cashout}</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowContainer>
    </div>
  );
}
